module.exports = __webpack_public_path__ + "img/field_blend_done_closeup.fc7448a7.jpg";